<template>
  <div class="card" v-if="noteableId">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Notes
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                    <CButton size="sm" color="primary" @click.stop.prevent="handleShowCreateModal()" class="mr-1"><i class="fa fa-plus"></i></CButton>
                </div><!--btn-toolbar-->
              </div><!--col-->
          </div><!--row-->
          <hr />
          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="20%">
                          <col width="50%">
                          <col width="15%">
                          <col width="15%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{{ $t('note.label.creator') }}</th>
                            <th>{{ $t('note.label.note') }}</th>
                            <th>{{ $t('note.label.created_at') }}</th>
                            <th>{{ $t('note.label.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(note, index) in notes" :key="index">
                            <td>{{ note.creator }}</td>
                            <td>{{ note.note }}</td>
                            <td>{{ note.created_at }}</td>
                            <td>
                               <CButton size="sm" color="primary" @click.stop.prevent="handleShowEdit(note)" class="mr-1"><i class="fa fa-pencil"></i></CButton>
                               <CButton size="sm" color="danger" @click.stop.prevent="handleDelete(note.id)"><i class="fa fa-trash"></i></CButton>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row">
                        <div class="col-sm-12 col-md-5">
                          <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                          <nav>
                            <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                          </nav>
                        </div>
                      </div>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
    <loading-panel v-if="showLoadingPanel"></loading-panel>
    <CModal
        title="Update Note"
        :show.sync="showEditModal"
        color="primary"
        size="lg"
      > 
        <div class="row mt-4">
            <div class="col">
                <div class="form-group row">
                    <label for="note" class="col-sm-2 col-form-label">Note</label>
                    <div class="col-sm-8">
                        <textarea rows="4" v-model.trim="editNote.note" type="text" name="note" class="form-control" />
                    </div>
                </div>
            </div><!--col-->
        </div><!--row-->
        <div slot="footer">
            <b-button type="submit" size="sm" @click.stop.prevent="handleUpdate" variant="primary"><i class="fa fa-dot-circle-o"></i> Update</b-button>
        </div>
      </CModal>
      <CToaster v-if="showAlertMessage" :autohide="3000">
        <CToast
          :show="showAlertMessage"
          position="static"
          title="Message"
        >
          {{ alertMessage }}
        </CToast>
      </CToaster>
    <CModal
        title="Create Note"
        :show.sync="showCreateModal"
        color="primary"
        size="lg"
      > 
        <note-form 
        :noteableType="noteableType" 
        :noteableId="noteableId" 
        :callback="handleCreateNoteCallback" 
        />
        <div slot="footer"></div>
     </CModal>
  </div><!--card-->
</template>

<script>
import LoadingPanel from '@/components/LoadingPanel'
import NoteForm from '@/components/NoteForm'

export default {
  name: 'NoteList',
  components: {
    LoadingPanel,
    NoteForm,
  },
  props: {
    noteableType: {
      type: String,
      default: undefined
    },
    noteableId: {
      type: Number,
      default: undefined
    },
  },
  mounted () {
    this.fetchNotes()
  },
  watch: {
    noteableId (newVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal) {
        this.fetchNotes()
      }
    }
  },
  data () {
    return {
      notes: [],
      meta: [],
      currentPage: 1,
      showLoadingPanel: false,
      showCreateModal: false,
      showEditModal: false,
      editNote:{},
      showAlertMessage: false,
      alertMessage: ""
    }
  },
  methods: {
    showMessageToaster (message) {
      this.showAlertMessage = true
      this.alertMessage = message
    },
    fetchNotes () {
      if (this.noteableId) {
          this.axios.get('/note', {
            params: {
            noteable_type: this.noteableType,
            noteable_id: this.noteableId,
            }
        }).then(response => {
            this.notes = response.data
            this.meta = response.meta
        }).catch(error => {
            console.log(error)
        })
      }
    },
    changePage (pageNum) {
      this.axios.get('/note', {
        params: {
          noteable_type: this.noteableType,
          noteable_id: this.noteableId,
          page: pageNum
        }
      }).then(response => {
        this.notes = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    },
    handleShowCreateModal () {
        this.showCreateModal = true
    },
    handleCreateNoteCallback() {
      this.showCreateModal = false
      this.fetchNotes();
    },
    handleShowEdit (note) {
        this.editNote = {...note}
        this.showEditModal = true
    },
    handleUpdate () {
      if (this.editNote) {
        // create supplier
        this.showLoadingPanel = true
        this.axios.put('/note/' + this.editNote.id, this.editNote).then(response => {
          this.showLoadingPanel = false
          this.showEditModal = false
          if(response.status === "success"){
            this.showMessageToaster(this.$t('note.update_success'))
            this.fetchNotes()
          }
        }).catch(error => {
          this.showLoadingPanel = false
          this.showMessageToaster(error.data.message)
        })
      }
    },
    handleDelete (noteId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button'),
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/note/' + noteId).then((response) => {
            this.showLoadingPanel = false
            if(response.status === "success"){
                this.showMessageToaster(this.$t('note.delete_success'))
                this.fetchNotes()
            }
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
